<script>
	import { clickOutside } from "../actions/clickOutside.js";

	import chevronDown from "../icons/chevron-down.svg";

	export let items;
	export let placeholder = "Select...";
	export let fallback = "No items found";
	export let selectedValue;
	export let disabled = window.matchMedia("(max-width: 640px)").matches;
	export let alignItems = "left";

	let isActive = false;
	let value;

	const inputHandler = () => {
		if (value != "") {
			for (let i = 0; i < items.length; i++) {
				items[i].label.toLowerCase().includes(value.trim().toLowerCase())
					? (items[i].hidden = false)
					: (items[i].hidden = true);
			}
		} else {
			items.map((item) => {
				item.hidden = false;
			});
		}
	};

	const clearSearch = () => {
		value = undefined;
		if (items) {
			items.map((item) => {
				item.hidden = false;
			});
		}
	};
</script>

<div
	aria-expanded={isActive}
	class="select"
	class:active={isActive}
	class:align-right={alignItems === "right"}
	class:align-left={alignItems === "left"}
	class:align-center={alignItems === "center"}
	use:clickOutside
	on:click_outside={() => (isActive = false)}
>
	{#if selectedValue}
		<div class="selected-value" on:click={() => (isActive = !isActive)}>
			<span class="selected-value-label">
				{selectedValue.label}
			</span>
			<img class="arrow" src={chevronDown} alt="" />
		</div>
	{:else}
		<div class="input-container" on:click={() => (isActive = !isActive)}>
			{#if items && items.length > 0}
				{#if !disabled}
					<input
						type="text"
						{placeholder}
						autocomplete="off"
						autocorrect="off"
						spellcheck="false"
						{disabled}
						bind:value
						on:input={inputHandler}
						class="input"
					/>
				{:else}
					<p class="input">
						{placeholder}
					</p>
				{/if}
			{:else}
				<input type="text" {placeholder} disabled class="input" />
			{/if}
		</div>
	{/if}
	{#if isActive}
		<div class="items" role="listbox">
			{#if items && items.length > 0}
				{#if items.every((obj) => obj.hidden === true)}
					<div
						class="item"
						on:click={() => {
							isActive = false;
						}}
					>
						{fallback}
					</div>
				{:else}
					{#each items as item}
						{#if !item.hidden}
							<div
								role="option"
								class="item"
								class:active={selectedValue === item}
								on:click={() => {
									isActive = false;
									selectedValue = item;
									clearSearch();
								}}
							>
								<span>{item.label}</span>
							</div>
						{/if}
					{/each}
				{/if}
			{:else}
				<div
					class="item"
					on:click={() => {
						isActive = false;
					}}
				>
					{fallback}
				</div>
			{/if}
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../main.scss";

	$background-light: #f9f9f9;
	$container-active-light: $grey;
	$border-light: #d8dbdf;
	$border-hover-light: #b2b8bf;
	$selected_value-light: #000;
	$input-light: #3f4f5f;
	$items-shadow-light: 0px 3px 10px rgba(0, 0, 0, 0.15);
	$items-item-light: #3f4f5f;
	$items-item-hover-light: $lightlightgrey;
	$items-item-active-light: $lightlightgrey;
	$items-item-selected-light: #fff;
	$items-item-selected-background-light: $grey;

	$height: 26px;

	.selected-value {
		display: flex;
		justify-content: space-between;
		align-items: center;
		z-index: 3;
		line-height: $height - 5px;
		border-radius: 3px;
	}

	.selected-value-label {
		overflow: hidden;
		overflow: clip;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-bottom: 1px solid $grey;
		padding: 0 2px;
		color: $selected-value-light;
	}

	.input-container {
		border-radius: 3px;
		position: absolute;
		height: 100%;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 2;
	}

	.input {
		background: transparent;
		border-radius: 3px;
		padding: 0;
		line-height: $height;
		height: 100%;
		cursor: default;
		width: calc(100% - 32px);
		border: none;
		margin: 0;
		&:focus {
			outline: none;
		}
	}

	.items {
		position: absolute;
		transform: translateY($height);
		width: fit-content;
		border: 2px solid #dadada;
		background: $background-light;
		border-radius: 6px;
		box-shadow: $items-shadow-light;
		overflow-y: auto;
		z-index: 4;
		&::-webkit-scrollbar {
			width: 8px;
			height: 8px;
			background-color: rgba(0, 0, 0, 0);
			border-radius: 100px;
		}
		&::-webkit-scrollbar:hover {
			background-color: rgba(0, 0, 0, 0.09);
		}
		&::-webkit-scrollbar-thumb {
			background: rgba(0, 0, 0, 0.5);
			border-radius: 100px;
		}
		&::-webkit-scrollbar-thumb:active {
			background: rgba(0, 0, 0, 0.61);
			border-radius: 100px;
		}
		&::-webkit-scrollbar-thumb:vertical {
			min-height: 10px;
		}
		&::-webkit-scrollbar-thumb:horizontal {
			min-width: 10px;
		}
		&::-webkit-resizer {
			background-color: transparent;
		}
	}

	.item {
		padding: 0 11px;
		height: $height;
		background: $background-light;
		display: flex;
		align-items: center;
		overflow: hidden;
		overflow: clip;
		span {
			height: 100%;
			padding: 0 2px;
			line-height: $height;
			border-bottom: 1px solid rgba($grey, 0);
		}

		&:hover {
			span {
				border-bottom-color: $grey;
			}
		}
		&:active {
			background: $items-item-active-light;
		}
		&.active {
			color: $items-item-selected-light;
			background: $items-item-selected-background-light;
		}
	}

	// > small tablets
	@media (min-width: #{$breakpoint-tablet-s + 1px}) {
		.selected-value-label {
			margin-right: 3px;
		}

		.arrow {
			width: 18px;
		}
	}

	// <= small tablets
	@media (max-width: $breakpoint-tablet-s) {
		.item {
			height: calc(100vh / 27);

			span {
				line-height: calc(100vh / 27);
			}
		}
		.arrow {
			width: 15px;
			margin-left: -2px;
		}

		.selected-value-label {
			margin-right: -1px;
		}
	}

	.select {
		outline: none;
		display: inline-flex;
		align-items: center;
		//height: $height;
		height: 1.2em;
		user-select: none;
		width: fit-content;
		flex-direction: column;
		&.align-left {
			align-items: flex-start;
		}
		&.align-right {
			align-items: flex-end;
		}
		&.align-center {
			align-items: center;
		}
		&.active {
			// border: 1px solid $container-active-light;
		}
		&:hover {
			cursor: pointer;
		}
	}
</style>
